import React from 'react'

export default function conChange(Comp){

	return class Wrapper extends React.Component{
		constructor(props){
			super(props)
			this.state={}
			
			
			this.handleConChange = this.handleConChange.bind(this)

		}
		handleConChange(key,val){
			
			this.setState({
				[key]:val
			})
			
			
		}

		render(){
			return <Comp handleConChange={this.handleConChange} state={this.state} {...this.props}></Comp>
		}
	}
}


// WEBPACK FOOTER //
// ./src/component/common/common.js